<template>
    <div class="top_filter">
        <!-- 부서 선택 컴포넌트 -->
        <ReservationGroupFilter v-if="!this.sheetState.isHoliday" />
        <!-- 담당자 선택 컴포넌트 -->
        <ReservationColumnFilter v-if="!this.sheetState.isHoliday" />
        <!-- 예약상태 선택 컴포넌트 -->
        <ReservationStateFilter v-if="!this.sheetState.isHoliday" />
        <!-- 시간간격 선택 컴포넌트 -->
        <ReservationIntervalFilter v-if="!this.sheetState.isHoliday" />
        <!-- 예약상태 구분 오버레이 컴포넌트 -->
        <ReservationStateOverlay v-if="!this.sheetState.isHoliday" />
        <div class="mgl_auto">
            <button class="btn_white btn btn_s ico" @click="handleExcelButtonClick"
                    v-if="!this.sheetState.isHoliday">
                <v-icon small>mdi-microsoft-excel</v-icon>
                {{ $t('reservationwindow.header.button_export_to_excel') }}
            </button>
            <button class="btn_white btn btn_s ico" @click="handleHistoryButtonClick">
                <v-icon small>mdi-clock-outline</v-icon>
                {{ $t('reservationwindow.header.button_appointment_history') }}
            </button>
            <button class="btn_white btn btn_s ico" @click="handleRefreshButtonClick">
                <v-icon small>mdi-reload</v-icon>
                {{ $t('reservationwindow.header.button_refresh') }}
            </button>
            <button class="btn_white btn btn_s ico" @click="handleShowSettingPopup">
                <v-icon small>mdi-cog</v-icon>
                {{ $t('reservationwindow.header.button_settings') }}
            </button>

        </div>
    </div>
</template>

<script>
import ReservationGroupFilter from './SubViews/ReservationGroupFilter.vue'
import ReservationColumnFilter from './SubViews/ReservationColumnFilter.vue'
import ReservationStateFilter from './SubViews/ReservationStateFilter.vue'
import ReservationIntervalFilter from './SubViews/ReservationIntervalFilter.vue'
import ReservationStateOverlay from './SubViews/ReservationStateOverlay.vue'

import { sheetState } from '../../sheet-state'
import { showExcelSavePopup, showReservationHistoryPopup } from '../../sheet-overlays'
import { handleRefresh } from '../../sheet-refresh'


export default {
    components: {
        ReservationGroupFilter,
        ReservationColumnFilter,
        ReservationStateFilter,
        ReservationIntervalFilter,
        ReservationStateOverlay
    },
    data() {
        return {
            sheetState,
        }
    },
    methods: {
        handleExcelButtonClick() {
            showExcelSavePopup()
        },
        handleHistoryButtonClick() {
            showReservationHistoryPopup()
        },
        handleRefreshButtonClick() {
            handleRefresh()
        },
        handleShowSettingPopup() {
            this.$emit('showSettingPopup')
        }
    }
}
</script>